import { render, staticRenderFns } from "./LoginRecovery.vue?vue&type=template&id=a367ecda"
import script from "./LoginRecovery.vue?vue&type=script&lang=js"
export * from "./LoginRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports